import { useState, useCallback, useEffect } from "react";

import useService from "../../../../../hooks/useService";
import { getModalHandler } from "../../../Common/Modals/hooks/useModalSingleton";
import { useProviderDetailStore } from "../store/provider-details/providerDetailStore";

export function useProviderTypes() {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [limit, setLimit] = useState(null);
  const [offset, setOffset] = useState(null);
  const { minProviderTypes, maxProviderTypes } = useProviderDetailStore();
  const { openFailureModal } = getModalHandler();

  const enumRepo = useService("repositories/enum-repository");

  const fetchProviderTypes = useCallback(
    async (append = false, isNewSearch = false, currentSearch = search) => {
      setLoading(true);
      try {
        const queryLimit = isNewSearch ? null : limit;
        const queryOffset = isNewSearch ? null : offset;
        if (isNewSearch) {
          setLimit(null);
          setOffset(null);
        }

        const params = {};
        if (currentSearch?.trim()) {
          params.search = currentSearch.trim();
        }
        if (queryLimit) {
          params.limit = queryLimit;
        }
        if (queryOffset) {
          params.offset = queryOffset;
        }

        const response = await enumRepo.query({
          urlPath: "core/dynamic-options/provider-type/",
          ...params,
        });

        const nextPageURL = await enumRepo.getNextPage();
        if (nextPageURL) {
          setShowMore(true);
          const url = new URL(nextPageURL);
          setLimit(parseInt(url.searchParams.get("limit")) || queryLimit);
          setOffset(parseInt(url.searchParams.get("offset")) || queryOffset);
        } else {
          setShowMore(false);
        }

        const mapped = response?.map((i) => ({ id: i.key, label: i.value })) || [];
        setData(append ? [...data, ...mapped] : mapped);
      } catch (error) {
        console.error(error);
        openFailureModal(error);
      } finally {
        setLoading(false);
      }
    },
    [search, limit, offset, enumRepo, data]
  );

  useEffect(() => {
    fetchProviderTypes(false, true);
  }, [search]);

  return {
    data,
    min: minProviderTypes,
    max: maxProviderTypes,
    search,
    setSearch,
    loading,
    showMore,
    handleShowMore: () => fetchProviderTypes(true, false),
  };
}
